import React, { useEffect, useState, Fragment } from 'react';
import { Link } from 'react-router-dom';
import axios from '../../api/axios';
import Skeleton from '@material-ui/lab/Skeleton';

const DriverLink = ({ driverId }) => {
  const [driver, setDriver] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(
          `/api/v1/admin/users/driverById/${driverId}`
        );

        setDriver(data);
      } catch (error) {
        console.error(JSON.stringify(error, null, 2));
      }
    })();
  }, []);

  return (
    <Fragment>
      {driver === null ? (
        <Skeleton variant="text" width={40} />
      ) : (
        <Link to={`/protected/admin/users/driver/${driverId}`}>
          {driver?.user?.legal
            ? driver?.user?.company
            : `${driver?.user?.firstName} ${driver?.user?.lastName} `}
        </Link>
      )}
    </Fragment>
  );
};

export default DriverLink;
